// PhoneCallUI.tsx
import React from 'react';
import { AddLabelPhoneCall } from 'web/pages/patients/objectives/AddLabelPhoneCall';
import { usePhoneCallStore } from 'web/hooks/usePhoneCallStore';

const PhoneCallUI: React.FC = () => {
    const { showPhoneCallUI, label, cancelAdd } = usePhoneCallStore();

    if (!showPhoneCallUI || !label) {
        return null;
    }

    return (
        <div className='fixed top-0 right-0 z-50 bg-white p-4 shadow-lg flex flex-col items-end mr-4 mt-4'>
            <AddLabelPhoneCall
                label={label}
                cancelAdd={cancelAdd}
            />
        </div>
    );
};

export default PhoneCallUI;
